export const RRS_DEBT_OVERVIEW = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Gjeldsoversikt – her finner du den gratis og enkelt',
  url: 'https://scoopr.no/gjeldsoversikt',
  description:
    'Har du forbrukslån og kanskje et kredittkort eller tre? Hvis du i tillegg har lån til bolig, bil og andre verdier kan det fort bli vanskelig å få total gjeldsoversikt. Vi har gjort det enklere for deg å finne ut hvor mye du har i usikret gjeld – og hvor mye du kan spare på å refinansiere.',
  datePublished: '2022-01-13T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
